import { NavigationSidebarBottomMenuItem } from '../types';

/**
 * Keeps only the bottom-section items that have somewhere to go.
 *
 * Every item in that section opens an external address, and the click handler bails out when the
 * address is missing — so an item without one renders as a button that silently ignores the user.
 * Whether an item appears and where it points are configured separately, both under
 * `environment.platform`, which makes enabling one without the other easy to miss and invisible
 * until somebody clicks. The mismatch is therefore reported rather than swallowed.
 */
export function selectLinkedBottomMenuItems(
  menuItems: NavigationSidebarBottomMenuItem[]
): NavigationSidebarBottomMenuItem[] {
  const linkedItems: NavigationSidebarBottomMenuItem[] = [];
  const identifiersWithoutLink: string[] = [];

  for (const menuItem of menuItems) {
    if (menuItem.href?.trim()) {
      linkedItems.push(menuItem);
    } else {
      identifiersWithoutLink.push(menuItem.identifier);
    }
  }

  if (identifiersWithoutLink.length > 0) {
    console.warn(
      `[navigation-sidebar] Enabled for this deployment but missing a link, so hidden: ${identifiersWithoutLink.join(
        ', '
      )}. Set the matching address under \`environment.platform\`, or hide the item with its own flag.`
    );
  }

  return linkedItems;
}
